import { render } from "./Users.vue?vue&type=template&id=54a43110&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "./Users.vue?vue&type=style&index=0&id=54a43110&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.22.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a43110"]])

export default __exports__